<template>
  <div class="profile">
    <div class="profile__title">
      <div
        class="profile__title-avatar"
        :style="`background: ${userAvatarColor(user.roles)}`"
      >
        <div class="avatar__cover" />
        {{ user.name && user.name[0].toUpperCase()
        }}{{ user.surname && user.surname[0].toUpperCase() }}
      </div>
      <div class="profile__title-name">
        {{ user.surname }}  <br v-if="user.name && user.patronymic" />
        {{ user.name }} {{ user.patronymic }}
      </div>
    </div>
    <div class="profile__info">
      <div
        v-for="item in info"
        :key="item.title"
        v-show="!item.hide"
        class="profile__info-item"
      >
        <div class="item__title">{{ item.title }}</div>
        <div v-if="item.type === 'email'" class="email">
          <a :href="`mailto:${item.text}`">{{ item.text }}</a>
        </div>
        <div v-else-if="item.type === 'department'">
          <div v-if="item.text.parent">
            <p v-if="item.text.parent.parent" class="parent-department">
              {{item.text.parent.parent.name}}
            </p>
            <p class="parent-department">
              /{{item.text.parent.name}}/
            </p>
          </div> 
          {{ item.text.name }}
        </div>
        <div v-else>
          {{ item.text }}
        </div>
      </div>

      <Button
        v-if="canLogout"
        @click="logout"
        :loading="false"
        class="btn-primary logout__button"
        width="113px"
        height="40px"
        text="Выход"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Button from "@/components/Button.vue";
import Auth from "@/utils/auth.js";

export default {
  components: { Button },
  props: {
    user: {
      type: Object,
      default: () => {
        return {
          email: "test@mail.ru",
        };
      },
    },
    info: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters("users", ["userAvatarColor"]),
    ...mapState("users", ["activeUser"]),
    canLogout() {
      return (
        this.$route.params.type === "users" &&
        this.activeUser?.id &&
        this.activeUser?.id === this.user?.id
      );
    },
  },
  methods: {
    logout() {
      Auth.logout();
      this.$router.push("/login");
    },
  },
};
</script>

<style lang="scss" scoped>
.profile {
  display: flex;
  // height: 315px;
  margin-top: 32px;

  @media screen and (max-width:1500px) {
    margin-top: 24px;
    // height: 250px;
  }

  .profile__title {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-shadow: 0px 8px 8px rgba(0, 32, 51, 0.04),
      0px 12px 28px rgba(0, 32, 51, 0.12);
    border-radius: 4px;
    margin-right: 33px;
    width: 330px;
    height: 282px;
    padding: 12px;

    @media screen and (max-width:1500px) {
      margin-right: 15px;
      width: 240px;
      height: 214px;
    }

    &-avatar {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 31.25px;
      text-align: center;
      background: $blue-user;
      border-radius: 20px;
      color: #ffffff;
      width: 100px;
      height: 100px;
      margin-bottom: 16px;
      position: relative;

      @media screen and (max-width:1500px) {
        width: 60px;
        height: 60px;
        margin-bottom: 7px;
        font-size: 18.75px;
      }
    }

    &-name {
      text-align: center;
      font-weight: 600;
      font-size: 20px;
      line-height: 150%;
    }
  }

  .profile__info {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: 1fr 1fr 1fr;
    width: 100%;
    height: 100%;
    border: 1px solid #97b2c4;
    box-sizing: border-box;
    border-radius: 4px;
    padding: 32px;
    position: relative;
    column-gap: 20px;
    row-gap: 30px;

    @media screen and (max-width:1500px) {
      row-gap: 24px;
    }

    .profile__info-item {
      .item__title {
        color: $dark-gray;
        line-height: 150%;
        margin-bottom: 4px;
      }
      .email a {
        color: $blue;
      }
    }

    @media screen and (max-width:1500px) {
      padding: 20px;
    }
  }

  .logout__button {
    position: absolute;
    right: 32px;
    bottom: 32px;

    @media screen and (max-width:1500px) {
      right: 20px;
      bottom: 20px;
    }
  }
}
.parent-department {
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
  color: rgba(0, 32, 51, 0.6);
  margin-bottom: 6px;
}
</style>
